import { inBrowser } from './runtime'

function checkFlag(key: string): boolean {
  if (!inBrowser()) return false

  const qualifiedKey = `sxp_sdk_${key}`

  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has(qualifiedKey)) {
    return true
  }

  if (typeof localStorage === 'undefined') {
    return false
  }
  return Boolean(localStorage?.[qualifiedKey])
}

export function useConsoleLogger(): boolean {
  return checkFlag('console_logger')
}

export function useEcSampleContent(): boolean {
  return checkFlag('ec_sample_content')
}

export function useEcDestinationTest(): boolean {
  return checkFlag('ec_destination_test')
}
